import { useState } from 'react'
import { useIntl } from 'react-intl'
import swalAlert from '../helpers/swalAlert'

const useRangeDate = ({ minDate, maxDate }) => {
  const { formatMessage: msg } = useIntl()

  const [initDate, setInitDate] = useState(minDate)
  const [finishDate, setFinishDate] = useState(maxDate)

  const onChangeRange = ({ target }) => {
    const name = target?.name
    const value = target?.value

    if (name === 'initDate') {
      setInitDate(value)
    }

    if (name === 'finishDate') {
      setFinishDate(value)
    }
  }

  const checkRange = () => {
    if (initDate > finishDate) {
      swalAlert.error(msg({ id: 'check.range.date.error' }))
      return false
    }
    return true
  }

  return {
    initDate,
    finishDate,
    onChangeRange,
    checkRange,
  }
}

export default useRangeDate
